import React, { useEffect } from "react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Seo from "../components/common/seo";
import AllProjects from "../components/projects/allProjects";
import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<React.Fragment>
			<Seo page="projects" />

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="projects-container">
						<div className="title projects-title">
							5 Years in IT: From Career Transition to Senior
							Analyst Programmer at SFC
						</div>

						<div className="subtitle projects-subtitle">
							After transitioning into tech during the post-COVID
							period, I moved from sneaker reselling into software
							engineering through Tecky Academy. Over 5 years of
							IT-related experience, I have progressed across Web
							Developer, Analyst Programmer, and Automation
							Developer roles, and now serve as a Senior Analyst
							Programmer at SFC. The projects below highlight this
							journey and the practical experience behind it.
						</div>

						<div className="projects-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
